module.exports = __webpack_public_path__ + "img/studingroom.ba79069e.png";